module.exports = {
  BUA: 'BUA',
  LAB_HAZARD: 'LAB_HAZARD',
  PESTICIDE_USE: 'PESTICIDE_USE',
  PROGRAM_FLEX: 'PROGRAM_FLEX',
  RESPIRATOR: 'RESPIRATOR',
  UNIT_RISK: 'UNIT_RISK',
};
